
import React from "react";
import { Check } from "lucide-react";
import { getThemeClasses } from "./SceneGeneratorTheme";
import { SceneGeneratorTheme } from "./types";

interface ItemsListProps {
  items: string[];
  theme?: SceneGeneratorTheme;
}

const ItemsList: React.FC<ItemsListProps> = ({ items, theme = "default" }) => {
  const themeClasses = getThemeClasses(theme);
  
  return (
    <div className={`rounded-md p-4 ${themeClasses.itemList}`}>
      <h3 className="font-medium text-lg mb-2">Items You'll Need:</h3>
      <ul className="space-y-2">
        {items.map((item, index) => (
          <li 
            key={index} 
            className={`flex items-start gap-2 p-2 rounded border ${themeClasses.item}`}
          >
            <span className={`mt-0.5 flex-shrink-0 rounded-full p-1 ${themeClasses.accent} bg-opacity-20`}>
              <Check className="h-4 w-4" />
            </span>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ItemsList;
